<template>
  <v-app-bar
    color="black"
    dense
    dark
    min-height="6.5vh"
    max-height="6.5vh"
    flat
    class="header-bar"
  >
    <v-toolbar-title class="toolbar-logo">
      <i
        @click="routeToDashboard"
        class="icon-hover"
        data-testid="navigation-logo"
        ><img
          alt="1"
          svg-inline
          src="@/assets/svg/3xLogo.svg"
          style="max-width: 160px; width: 100%; height: 60px"
      /></i>
    </v-toolbar-title>
    <v-tabs
      height="6.5vh"
      model="tab"
      slider-color="red"
      slider-size="4"
      :optional="navTabsOptional"
      v-model="tabsModel"
      :hide-slider="navTabsOptional"
    >
      <template v-if="isLoggedIn">
        <v-tab
          to="/dashboard"
          active-class="nav-active"
          @click.native="clickTrack('dashboard')"
          data-testid="navigation-dashboard"
        >
          <i><img alt="2" svg-inline src="@/assets/svg/dashboard.svg" /></i>
          {{ $t('navigation.dashboard') }}
        </v-tab>
        <v-tab
          to="/locations"
          active-class="nav-active"
          @click.native="clickTrack('locations')"
          data-testid="navigation-locations"
        >
          <v-icon color="white" size="14">mdi-map-marker</v-icon>
          {{ $t('navigation.locations') }}
        </v-tab>
        <v-tab
          to="/library"
          active-class="nav-active"
          v-if="showCaseLibrary"
          @click.native="clickTrack('library')"
          data-testid="navigation-library"
        >
          <i><img alt="3" svg-inline src="@/assets/svg/library.svg" /></i>
          {{ $t('navigation.caseLibrary') }}
        </v-tab>
        <v-tab
          to="/views"
          active-class="nav-active"
          data-testid="navigation-views"
          v-if="hasMultiView"
        >
          <i><img alt="4" svg-inline src="@/assets/svg/viewIcon.svg" /></i>
          {{ $t('navigation.views') }}
        </v-tab>
        <v-tab
          to="/search"
          active-class="nav-active"
          v-if="hasSearchView"
          @click.native="clickTrack('search')"
          data-testid="navigation-search"
        >
          <v-icon color="white" size="14">mdi-magnify</v-icon>
          {{ $t('navigation.search') }}
        </v-tab>
        <v-tab
          to="/admin"
          active-class="nav-active"
          v-if="showAdmin"
          @click.native="clickTrack('admin')"
          data-testid="navigation-customer-admin"
        >
          <i>
            <img
              alt="5"
              svg-inline
              class="gear-icon-tweak"
              src="@/assets/svg/gear.svg"
          /></i>
          {{ $t('navigation.administration') }}
        </v-tab>
      </template>
      <template v-if="!isLoggedIn && !externalCloudCases">
        <v-tab :to="sharedCasesLink" active-class="nav-active">
          <i><img alt="6" svg-inline src="@/assets/svg/library.svg" /></i>
          {{ $t('navigation.caseLibrary') }}
        </v-tab>
      </template>
    </v-tabs>
    <v-spacer></v-spacer>
    <NotificationsIcon v-if="isLoggedIn" />
    <AccountMenu v-if="isLoggedIn" />
  </v-app-bar>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AccountMenu from './../AccountMenu.vue'
import NotificationsIcon from '../notifications/NotificationsIcon.vue'
import {
  DASHBOARD_NAV_CLICK,
  LOCATIONS_NAV_CLICK,
  LIBRARY_NAV_CLICK,
  ADMIN_NAV_CLICK,
} from '@/constants/mixpanelEvents'

export default defineComponent({
  name: 'CustomerUserDesktopNav',
  components: {
    AccountMenu,
    NotificationsIcon,
  },
  data() {
    return {
      tabsModel: null,
    }
  },
  props: {
    showAdmin: {
      type: Boolean,
      required: true,
    },
    showCaseLibrary: {
      type: Boolean,
      required: true,
    },
    navTabsOptional: {
      type: Boolean,
      required: true,
    },
    hasMultiView: {
      type: Boolean,
      required: true,
    },
    hasSearchView: {
      type: Boolean,
      required: true,
    },
    isLoggedIn: {
      type: Boolean,
      required: true,
    },
    queryString: {
      type: String,
      required: false,
    },
    externalCloudCases: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    routeToDashboard() {
      if (this.isLoggedIn) {
        this.$router.push('/dashboard')
        this.$mixpanelUserTrack(DASHBOARD_NAV_CLICK)
      }
    },
    clickTrack(navItem) {
      if (navItem === 'dashboard') {
        this.$mixpanelUserTrack(DASHBOARD_NAV_CLICK)
      } else if (navItem === 'locations') {
        this.$mixpanelUserTrack(LOCATIONS_NAV_CLICK)
      } else if (navItem === 'library') {
        this.$mixpanelUserTrack(LIBRARY_NAV_CLICK)
      } else if (navItem === 'admin') {
        this.$mixpanelUserTrack(ADMIN_NAV_CLICK)
      }
    },
  },
  watch: {
    checkTabsModel: {
      handler() {
        if (this.checkTabsModel.navTabsOptional) {
          this.tabsModel = ''
        } else if (!this.checkTabsModel.isLoggedIn) {
          this.tabsModel = true
        }
      },
      deep: true,
    },
  },
  computed: {
    checkTabsModel() {
      return {
        navTabsOptional: this.navTabsOptional,
        isLoggedIn: this.isLoggedIn,
      }
    },
    sharedCasesLink() {
      return { name: 'SharedCases', query: { h: this.queryString } }
    },
  },
})
</script>
